jQuery(function ( $ ) {
	'use strict';

	if ( ! $( document.body ).hasClass( 'single-sekcja' ) ) {
		return;
	}

	document.cookie = 'sekcjakarpatkowa=yes;path=' + wps.cookie_path + ';domain=' + wps.cookie_domain;

	var $recipes = $( '.sk-recipes' ),
		$window = $( window ),
		loading = false,
		list_item_height, list_bottom, loadMore, calcEdge;

	$window.on( 'load resize', calcEdge ).on( 'scroll', function () {
		var scrollTop = $window.scrollTop() + $window.height();

		if ( scrollTop > list_bottom - list_item_height * 2 ) {
			if ( ! loading ) {
				loadMore();
			}
		}
	});

	calcEdge = function () {
		list_bottom = $recipes.find( '.sk-recipe' ).last()[0].getBoundingClientRect().top;
		list_item_height = $recipes.find( '.sk-recipe' ).last().outerHeight();
	};

	calcEdge();

	loadMore = function () {
		if ( loading ) {
			return;
		}

		loading = true;

		$.get( wps.ajax, {
			action: 'wiecej_karpatek',
			offset: $recipes.find( '.sk-recipe' ).not( '.sk-recipe--featured' ).length,
			section_id: wps.ID
		}, function ( response ) {
			if ( ! response.success ) {
				return;
			} else {
				$( response.data.html ).appendTo( $recipes.find( '> .wrapper' ) );
				loading = false;
				calcEdge();
			}
		});
	};
});
